import { render, staticRenderFns } from "./USConstituentPanel.vue?vue&type=template&id=68ab9300&scoped=true"
import script from "./USConstituentPanel.vue?vue&type=script&lang=js"
export * from "./USConstituentPanel.vue?vue&type=script&lang=js"
import style0 from "./USConstituentPanel.vue?vue&type=style&index=0&id=68ab9300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ab9300",
  null
  
)

export default component.exports